import React, { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import BusinessInfo from "./BusinessInfo";
import WorkoutTemplate from "./WorkoutTemplate";
import Exercises from "./Exercises";
import Recipes from "./Recipes";
// import Form from "./Form";
import ContentLibrary from "./ContentLibrary";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function Toolbox() {
  const { trans } = useCustomTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "businessInfo"
  );
  const { profileData } = useSelector((state) => state.profile);
  const coachId = profileData?.coachId;

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  return (
    <div className=" formContainer">
      <Tabs
        activeKey={activeTab}
        onSelect={handleSelect}
        id="controlled-tab-example"
        className="mb-3 fs-5"
      >
        <Tab eventKey="businessInfo" title={trans("Toolbox.businessInfo")}>
          {activeTab === "businessInfo" && <BusinessInfo />}
        </Tab>
        <Tab
          eventKey="workoutTemplate"
          title={trans("Toolbox.workoutTemplates")}
        >
          {activeTab === "workoutTemplate" && <WorkoutTemplate />}
        </Tab>
        <Tab eventKey="exercises" title={trans("Toolbox.exercises")}>
          {activeTab === "exercises" && <Exercises />}
        </Tab>
        <Tab eventKey="recipes" title={trans("Toolbox.recipes")}>
          {activeTab === "recipes" && <Recipes coachId={coachId} />}
        </Tab>
        {/* Move to phase 2 */}
        {/* <Tab eventKey="form" title={trans('Toolbox.form')}>
          <Form />
        </Tab> */}
        <Tab eventKey="contentLibrary" title={trans("Toolbox.contentLibrary")}>
          {activeTab === "contentLibrary" && <ContentLibrary />}
        </Tab>
      </Tabs>
    </div>
  );
}

export default Toolbox;
